function ChartBubble(chart, chartDataSelect, chartContainer, dateFrom, dateTo) {
  // ################################################### COLORS #############################################################
  var title = chartContainer.querySelector(".titleContainer > h5");
  var subTitle = chartContainer.querySelector(".titleContainer > h6");
  var legend = chartContainer.querySelector(".legend");
  legend.innerHTML = "";
  legend = legend.appendChild(document.createElement("ul"));
  var additionalInformation = chartContainer.querySelector(
    ".additionalInformation"
  );
  // #########################################################################################################################
  var selected = chartDataSelect.getSelected();
  var lastDeal;

  var datasets = [];
  var labels = [];
  var backgroundColor = [];
  var fac = 4;

  if (selected.PARTNERGROUP) {
    title.innerText = lng.get("dashboard-customers");

    var customers;
    var edges = chartDataSelect.getEdgesFromSelectors();
    var id;
    var type;
    var typeName;

    var from = moment(dateFrom, "DD.MM.YYYY");
    var to = moment(dateTo, "DD.MM.YYYY");
    var len = parseInt(moment(to).diff(from, "days")) + 1;

    var date = moment(from);
    for (var i = 0; i < len; ++i, date.add(1, "days")) {
      labels.push(date.format("ddd, DD.MM.YYYY"));
    }

    chart.options.scales.xAxes[0].ticks.callback = function (v, i, a) {
      return labels[v];
    };

    chart.options.tooltips.callbacks.label = function (tooltipItems, data) {
      return (
        data.datasets[tooltipItems.datasetIndex].label +
        ": " +
        data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].r /
          fac
      );
    };

    if (selected.EMPLOYEE) {
      id = selected.EMPLOYEE;
      type = ChartDataX.EMPLOYEE;
      typeName = lng.get("employee");
    } else if (selected.PARTNER) {
      id = selected.PARTNER;
      type = ChartDataX.PARTNER;
      typeName = lng.get("partner");
    } else {
      id = selected.PARTNERGROUP;
      type = ChartDataX.PARTNERGROUP;
      typeName = lng.get("partnerGroup");
    }

    if (id === ChartDataSelectX.ALL) {
      subTitle.innerText =
        lng.get("dashboard-per") +
        " " +
        typeName +
        " " +
        lng.get("dashboard-per-day-hour");
      var pGpes = chartDataSelect.data.getArrayData(type, edges);

      pGpes.sort(function (a, b) {
        if (a[1] < b[1]) return -1;
        if (b[1] < a[1]) return 1;
        return 0;
      });

      customers = chartDataSelect.data.getArrayData(ChartDataX.CUSTOMER, edges);
      for (let i = 0; i < pGpes.length; ++i) {
        var _id = pGpes[i][0];
        var name = pGpes[i][1];
        var color = pGpes[i][2];
        var data = [];

        var _edges = SetX.intersection(
          chartDataSelect.data.getNameColorEdgesFromId(_id)[2],
          edges
        );
        var customers = chartDataSelect.data.getArrayData(
          ChartDataX.CUSTOMER,
          _edges
        );

        var customersDayHour = [];

        for (var j = 0; j < len; ++j) {
          customersDayHour.push([
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
            [0, 0],
          ]);
        }

        var first = moment(dateFrom, "DD.MM.YYYY");
        for (var j = 0; j < customers.length; ++j) {
          var now = moment(customers[j][1]);
          var day = parseInt(moment(now).diff(first, "days"));
          var hour = parseInt(now.format("H"));
          var min = parseInt(now.format("m"));
          ++customersDayHour[day][hour][0];
          customersDayHour[day][hour][1] += min;
        }

        for (var j = 0; j < len; ++j) {
          for (var k = 0; k < 24; ++k) {
            if (customersDayHour[j][k][0] > 0) {
              var min =
                customersDayHour[day][hour][1] / customersDayHour[day][hour][0];
              data.push({
                x: j,
                y: k + min / 60,
                r: customersDayHour[day][hour][0] * fac,
              });
            }
          }
        }

        backgroundColor.push(color);

        datasets.push({
          data: data,
          backgroundColor: color,
          label: name,
        });

        var legendItem = document.createElement("li");
        var legendItemIcon = document.createElement("i");
        legendItemIcon.setAttribute("class", "material-icons");
        legendItemIcon.style.color = color;
        legendItemIcon.innerText = "fiber_manual_record";
        var legendItemText = document.createElement("span");
        legendItemText.innerText = name + " [" + customers.length + "]";

        legendItem.addEventListener("click", function (e) {
          var hidden = (chart.getDatasetMeta(i).hidden =
            !chart.getDatasetMeta(i).hidden);
          chart.update();
          e.target.parentElement.querySelector("span").style =
            "text-decoration:" + (hidden ? "line-through" : "none") + ";";
        });

        legendItem.appendChild(legendItemIcon);
        legendItem.appendChild(legendItemText);
        legend.appendChild(legendItem);
      }
    } else {
      var dataFromId = chartDataSelect.data.getNameColorEdgesFromId(id);
      var name = dataFromId[0];
      var color = dataFromId[1];
      var data = [];
      var _edges = SetX.intersection(dataFromId[2], edges);

      subTitle.innerText =
        lng.get("dashboard-from") +
        " " +
        name +
        " " +
        lng.get("dashboard-per-day-hour");

      var customers = chartDataSelect.data.getArrayData(
        ChartDataX.CUSTOMER,
        _edges
      );

      var customersDayHour = [];

      for (var j = 0; j < len; ++j) {
        customersDayHour.push([
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
          [0, 0],
        ]);
      }

      var first = moment(dateFrom, "DD.MM.YYYY");
      for (var j = 0; j < customers.length; ++j) {
        var now = moment(customers[j][1]);
        var day = parseInt(moment(now).diff(first, "days"));
        var hour = parseInt(now.format("H"));
        var min = parseInt(now.format("m"));
        ++customersDayHour[day][hour][0];
        customersDayHour[day][hour][1] += min;
      }

      for (var j = 0; j < len; ++j) {
        for (var k = 0; k < 24; ++k) {
          if (customersDayHour[j][k][0] > 0) {
            var min =
              customersDayHour[day][hour][1] / customersDayHour[day][hour][0];
            data.push({
              x: j,
              y: k + min / 60,
              r: customersDayHour[day][hour][0] * fac,
            });
          }
        }
      }

      backgroundColor.push(color);

      datasets.push({
        data: data,
        backgroundColor: color,
        label: name,
      });

      var legendItem = document.createElement("li");
      var legendItemIcon = document.createElement("i");
      legendItemIcon.setAttribute("class", "material-icons");
      legendItemIcon.style.color = color;
      legendItemIcon.innerText = "fiber_manual_record";
      var legendItemText = document.createElement("span");
      legendItemText.innerText = name + " [" + customers.length + "]";

      legendItem.addEventListener("click", function (e) {
        var hidden = (chart.getDatasetMeta(0).hidden =
          !chart.getDatasetMeta(0).hidden);
        chart.update();
        e.target.parentElement.querySelector("span").style =
          "text-decoration:" + (hidden ? "line-through" : "none") + ";";
      });

      legendItem.appendChild(legendItemIcon);
      legendItem.appendChild(legendItemText);
      legend.appendChild(legendItem);
    }
    customers.sort(function (a, b) {
      if (a[1] < b[1]) return 1;
      if (b[1] < a[1]) return -1;
      return 0;
    });
    if (customers.length > 0) {
      lastDeal = new moment(customers[0][1]);
    }
  } else {
    title.innerText = "";
    subTitle.innerText = "";
  }

  chart.chart.config.data = {
    datasets: datasets,
  };

  additionalInformation.innerHTML = `<i class="material-icons">history</i>
        <span>
            ${
              lastDeal
                ? lng.get("dashboard-last-customer") +
                  ": " +
                  lastDeal.format("LLLL")
                : lng.get("dashboard-no-customers")
            }
        </span>`;
  chart.update();
}
